// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var $$Array     = require("bs-platform/lib/js/array.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var V4          = require("uuid/v4");
var Caml_float  = require("bs-platform/lib/js/caml_float.js");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");

function parseGiphyJson(json) {
  return /* record */[
          /* id */"",
          /* value */Json_decode.field("id", Json_decode.string, json),
          /* isGuesed : false */0,
          /* url */Curry._1(Json_decode.at(/* :: */[
                    "images",
                    /* :: */[
                      "fixed_height",
                      /* :: */[
                        "url",
                        /* [] */0
                      ]
                    ]
                  ], Json_decode.string), json),
          /* width */Curry._1(Json_decode.at(/* :: */[
                    "images",
                    /* :: */[
                      "fixed_height",
                      /* :: */[
                        "width",
                        /* [] */0
                      ]
                    ]
                  ], Json_decode.string), json),
          /* height */Curry._1(Json_decode.at(/* :: */[
                    "images",
                    /* :: */[
                      "fixed_height",
                      /* :: */[
                        "height",
                        /* [] */0
                      ]
                    ]
                  ], Json_decode.string), json)
        ];
}

function parseGiphyResponseJson(json) {
  var gifs = Json_decode.field("data", (function (param) {
          return Json_decode.array(parseGiphyJson, param);
        }), json);
  var gifsWithPairs = $$Array.map((function (gif) {
          var newrecord = gif.slice();
          newrecord[/* id */0] = V4();
          return newrecord;
        }), $$Array.append(gifs, gifs));
  $$Array.sort((function (_, _$1) {
          return Caml_float.caml_float_compare(0.5 - Math.random(), 0.0);
        }), gifsWithPairs);
  return gifsWithPairs;
}

exports.parseGiphyJson         = parseGiphyJson;
exports.parseGiphyResponseJson = parseGiphyResponseJson;
/* uuid/v4 Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/GiphyApiDecoder.re
// module id = 46
// module chunks = 0